<form>
  <mat-card class="cur-card result-area" *ngIf="hasResult">
    <mat-card-header>
      <mat-card-title>申込書一覧</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="table-responsive">
        <table mat-table
          [dataSource]="dataSource">
          <ng-container matColumnDef="select">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>
              <mat-checkbox
                color="primary"
                (change)="selectAll()"
                [checked]="checkedAll"
              />
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                color="primary"
                (change)="selectOne(row)"
                [checked]="selection.isSelected(row)"
              />
            </td>
          </ng-container>
          <ng-container matColumnDef="creditRecpNo">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>受付番号</th>
            <td mat-cell *matCellDef="let row">{{ row.creditRecpNo }}</td>
          </ng-container>
          <ng-container matColumnDef="acceptDate">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>受付日時</th>
            <td mat-cell *matCellDef="let row">{{ row.acceptDate | date : 'YYYY/MM/dd HH:mm' }}</td>
          </ng-container>
          <ng-container matColumnDef="acceptbase">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>受付拠点（会社）</th>
            <td mat-cell *matCellDef="let row">{{ row.acceptbase }}</td>
          </ng-container>
          <ng-container matColumnDef="acceptorg">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>受付拠点（組織）</th>
            <td mat-cell *matCellDef="let row">{{ row.acceptorg }}</td>
          </ng-container>
          <ng-container matColumnDef="tantousha">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>受付担当者</th>
            <td mat-cell *matCellDef="let row">{{ row.tantousha }}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>申込書送付ステータス</th>
            <td mat-cell *matCellDef="let row">{{ row.status }}</td>
          </ng-container>
          <ng-container matColumnDef="requestType">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>申込書種別</th>
            <td mat-cell *matCellDef="let row">{{ row.requestType }}</td>
          </ng-container>
          <ng-container matColumnDef="billingCstmrNo">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>支払契約番号</th>
            <td mat-cell *matCellDef="let row">{{ row.billingCstmrNo }}</td>
          </ng-container>
          <ng-container matColumnDef="billingCstmrName">
            <th mat-header-cell class="border-bottom-double" *matHeaderCellDef>送付先宛名</th>
            <td mat-cell *matCellDef="let row">{{ row.billingCstmrName }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true" ></tr>
          <tr mat-row 
            *matRowDef="let row; columns: displayedColumnsCol"
            class="clickable-mat-row"
            (click)="clickRow(row, $event)"
          ></tr>
        </table>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="end center" width="30%">
        <mat-card-actions class="btn_area_right">
          <button type="button" mat-raised-button
            [disabled]="selection.selected.length == 0"
            color="primary"
            class="btn btnPrint"
            (click)="onClickPrint()"
          >印刷</button>
        </mat-card-actions>
      </div>
    </mat-card-content>
  </mat-card>
</form>
